<template>

     <section v-if="visible" class="hero is-primary is-fullheight has-shadow" style="background-color:#000f4f">
        <div class="hero-body">
            <div class="container has-text-centered">
                <div class="column is-4 is-offset-4">
                    <br><br>
                            <a class="link" @click='regresar' ><i class="fa fa-arrow-left" aria-hidden="true"></i>
                            Regresar</a>
                        <br><br>
                    <router-link to="/nuevo" class="button is-warning">
                        <b>Soy nuevo anunciante</b>
                    </router-link>   
                    <hr class="login-hr">
                    <p class="subtitle has-text-white">Registro de su entrada</p>
                    <div class="box" align="center" >
                        <div class="field">
                            <div class="control">
                                <input class="input is-small" type="email" placeholder="Email" autofocus v-model='persona.email' >
                            </div>
                        </div>
                        <div class="field">
                            <div class="control">
                                <input class="input is-small" type="password" placeholder=" Password" v-model='persona.suClave' >
                            </div>
                        </div>

                        <button class="button is-block is-info is-small is-fullwidth" @click="entrar" style="background-color:#bd0051S">Entrar          
                            <i class="fa fa-sign-in" aria-hidden="true"></i>
                        </button>
                    </div>
                    <p>
                        <router-link to="/nuevo" class="button is-warning">
                            <b>Soy nuevo anunciante</b>
                        </router-link>   
                        <br><br>
                        <a  @click="olvido">Olvidé mi password</a>
                        <br><br>
                            <a class="link" @click='regresar' ><i class="fa fa-arrow-left" aria-hidden="true"></i>
                            Regresar</a><br><br>
                        <br><br>

                    </p>
                </div>
            </div>
        </div>
    </section>
</template>

<script>

import axios from 'axios';

export default{
        name:'entrada',
        props: ['autorizadoGeneral'],  
        data(){
            return {
                visible: "",
                persona:{
                    email:'',
                    suClave:''
                },
                parametro:""
            };
        },
        mounted(){
            this.visible = true;
            this.parametro = this.vectoruno;
        },
        methods:{
            entrar(){
                var router = this.$router;

                axios.post('https://www.rentas-ventas.com/validando.php?elmail1='+this.persona.email + '&&clavetina=' + this.persona.suClave)
                        .then((respue) => {
                            if (this.persona.email !=''){
                                var pase = respue.data.includes("pasele*");
                                var folioPersona = respue.data.replace("pasele*", "");

                                if(pase){   
                                    alert("\n\nBienvenido " + this.persona.email ); 
                                    this.visible = true; 
                                    this.$emit('autorizado', this.persona.email);  
                                    this.$emit('folioPersonal', folioPersona); 
                                    this.$emit('apagar1')

                                    router.push('/productosMios');  
                                }else{
                                    alert("Usuario o clave incorrectos");
                                    router.push('/entrar');
                                }
                             }   
                            
                        })
                        .catch((error) =>{
                            alert("Servidor o wifi no disponible por el momento o algun dato no es aceptado");
                            router.push('/entrar');
                        });                     
            },
            olvido(){
                if(this.persona.email == "" || this.persona.email.includes('@') != true){
                    alert("\n\nFavor de ingresar su mail correctamente1 para \nenviarle su password. \nGracias.")
                }else{
                    axios.post('https://www.rentas-ventas.com/olvido.php?em12='+this.persona.email)
                        .then((respue) => {
                            alert("\n\nHemos enviado su password a " + this.persona.email + " \n\nRevisar incluso en la bandeja de spam \nen un momento mas por favor.");
                        })
                        .catch((error) =>{
                            alert("\n\n\n\n\nServidor o wifi no disponible por el momento");
                            this.$emit('cerrar');
                        });                
                }
            },
            regresar(){
                this.$emit('regresar'); 
                this.$router.go(-1);

            }          
        }
}

    
</script>

<style>
    
</style>


// WEBPACK FOOTER //
// src/Entrar.vue